import React from 'react';
import { Link } from 'react-router-dom';
import { FaClipboardList, FaRegFileAlt, FaTrophy, FaWpforms } from 'react-icons/fa';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import 'bootstrap/dist/css/bootstrap.min.css';

const Dashboard = () => {
    return (
        <div className="mt-1 d-flex flex-column" style={{ minHeight: '100vh' }}>

            <img src={H1} alt="item" className="img-fluid w-100" style={{ height: 'clamp(100px, 25vw, 150px)', objectFit: 'cover', }} />

            <div className="container mt-5">
                <div className="row g-3 justify-content-center">
                    {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
                        <Link to="/session-topic" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }}>
                            <FaClipboardList style={{ fontSize: '20px' }} />
                            <span>Session Topic</span>
                        </Link>
                    </div> */}
                    {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
                        <Link to="/feedback-form" style={{
                            padding: '12px 24px', fontSize: '16px', borderRadius: '8px',
                            border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center',
                        }}>
                            <FaRegFileAlt style={{ fontSize: '20px' }} />
                            <span>Feedback Form</span>
                        </Link>
                    </div> */}
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
                        <Link to="/" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }} >
                            <FaWpforms style={{ fontSize: '20px' }} />
                            <span>Awards</span>
                        </Link>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
                        <Link to="/awards-nomination" style={{ padding: '12px 24px', fontSize: '16px', borderRadius: '8px', border: 'none', backgroundColor: '#3498db', color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center', }}>
                            <FaTrophy style={{ fontSize: '20px' }} />
                            <span>Awards Nomination Data</span>
                        </Link>
                    </div>
                </div>
            </div>

            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto', }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>Powered by<a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>EMedha Technologies</a></p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer"><img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} /></a>
                </div>
            </footer>
        </div>
    );
};

export default Dashboard;
